import Vue from 'vue'
// import slideNav from '@/components/slideNav'
import selectPop from '@/components/selectPop'



Vue.component(selectPop.name, selectPop)